import React, { useState } from 'react'
import { IoMdClose } from 'react-icons/io'
import CTA from './styles'
import iconAgenda from '../../icons/icon-agenda.svg'

export default function AgendarVisita() {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <>
      {isOpen && (
        <CTA>
          <span>
            <img src={iconAgenda} alt="Agendar visita" />
            <strong>Agende uma visita</strong>, vamos adorar receber você.
          </span>
          <button type="button" onClick={() => setIsOpen(false)}>
            <IoMdClose size="1.2em" />
          </button>
          {/*<Link to="/agendamento-de-visitas">Quero agendar uma visita</Link>*/}
          <a
            href="https://gruposantajoana.com.br/videochamada/hmsj/"
            target="_blank"
            rel="noreferrer"
          >
            Quero agendar uma visita
          </a>
        </CTA>
      )}
    </>
  )
}
